import { type DocumentNode, gql } from '@apollo/client';

const updateMediaPermission: DocumentNode = gql`
  mutation update_media_permission(
    $mediaPermissionId: ID!
    $canEdit: Boolean
    $canShare: Boolean
    $canDownload: Boolean
    $canDelete: Boolean
    $hires: Boolean
  ) {
    updateMediaPermission(
      mediaPermissionId: $mediaPermissionId
      canEdit: $canEdit
      canShare: $canShare
      canDownload: $canDownload
      canDelete: $canDelete
      hires: $hires
    ) {
      mediaPermission {
        id
        profile {
          id
          user {
            username
          }
        }
        permissionsGroup {
          id
          name
        }
      }
    }
  }
`;

export default updateMediaPermission;
